import { create } from 'zustand';

export const NOTIFICATION_MAX = 100;

export interface AppNotification {
  id: string;
  type: string;
  message: string;
  title?: string;
  priority: 'low' | 'medium' | 'high' | 'critical';
  receivedAt: Date;
  read: boolean;
}

interface NotificationState {
  notifications: AppNotification[];
  unreadCount: number;
  addNotification: (n: AppNotification) => void;
  markAllRead: () => void;
  markRead: (id: string) => void;
  clear: () => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  notifications: [],
  unreadCount: 0,
  addNotification: (n) =>
    set((state) => ({
      notifications: [n, ...state.notifications].slice(0, NOTIFICATION_MAX),
      unreadCount: state.unreadCount + 1,
    })),
  markAllRead: () =>
    set((state) => ({
      unreadCount: 0,
      notifications: state.notifications.map((notification) => ({ ...notification, read: true })),
    })),
  markRead: (id) =>
    set((state) => {
      const target = state.notifications.find((notification) => notification.id === id);
      if (!target || target.read) return state;
      return {
        notifications: state.notifications.map((notification) =>
          notification.id === id ? { ...notification, read: true } : notification
        ),
        unreadCount: Math.max(0, state.unreadCount - 1),
      };
    }),
  clear: () => set({ notifications: [], unreadCount: 0 }),
}));
